import styled from "@emotion/styled";
import { PRIMARY_BLUE, SECONDARY_GREY, HEADING } from "src/constants/colors";

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ToggleLabel = styled.span<{ $active: boolean }>`
  font-size: 16px;
  font-weight: 500;
  color: ${({ $active }) => ($active ? HEADING : SECONDARY_GREY)};
  transition: color 0.2s;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  cursor: pointer;
`;

export const ToggleSlider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${SECONDARY_GREY};
  border-radius: 32px;
  transition: 0.4s;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }

  input:checked + & {
    background-color: ${PRIMARY_BLUE};
  }

  input:checked + &:before {
    transform: translateX(24px);
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;
